<template>
  <div>
    <header class="flex-end">
      <el-button
        type="primary"
        @click="open"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      ></el-table-column>
      <el-table-column label="配置类型">
        <template slot-scope="scope">
          <span v-if="scope.row.configType == 1">智能眼镜</span>
          <span v-if="scope.row.configType == 2">AI盒子(默认版本)</span>
          <span v-if="scope.row.configType == 4">AI盒子(造楼机版本)</span>
        </template>
      </el-table-column>
      <el-table-column label="配置内容">
        <template slot-scope="scope">
          <div v-if="scope.row.configType == 1">
            <p>userKey:{{scope.row.userKey}}</p>
            <p>appID:{{scope.row.appId}}</p>
            <p>appkey:{{scope.row.appKey}}</p>
            <p>appsecret:{{scope.row.secret}}</p>
          </div>
          <p v-if="scope.row.configType == 2">customerNumber:{{scope.row.appId}}</p>
          <p v-if="scope.row.configType == 4">
            customerNumber:{{scope.row.appId}} <br />
            监控设备:{{ formatDeviceNames(scope.row.extendJson) || '无监控设备' }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="绑定时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <edit-dialog
      ref="editDialog"
      @updateList="handlerSearch"
      :videos="videos"
    ></edit-dialog>

  </div>
</template>

<script>
import {
  Api_role,
  Api_setting
} from '@/api/api'
import { getStore } from '@/util/store'
import EditDialog from './editDialog'
export default {
  components: {
    EditDialog,
  },
  data() {
    return {
      status: -1,
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      addDialogVisible: false,
      configType: 0,//1-智能眼镜 2-AI盒子 3-Pkpm模,3目前没用
      companyId: getStore({ name: 'companyId' }),
      itemId: '',
      projectId: getStore({ name: 'projectId' }),
      editId: 0,
      videos: [],
    };
  },
  created() {
    this.handlerSearch()
    this.getVideoListFunc()
  },
  methods: {
    formatDeviceNames(extendJson) {
      try {
        const deviceIds = JSON.parse(extendJson || '[]');
        return deviceIds
          .map(id => {
            const device = this.videos.find(v => v.id === id);
            return device ? device.deviceName : `未知设备(${id})`;
          })
          .join(', ');
      } catch (e) {
        console.error('设备ID解析失败:', e);
        return '数据格式错误';
      }
    },

    async getVideoListFunc() {
      const params = { pageSize: 10000, pageIndex: 1 }
      const { data: { data, statusCode } } = await Api_setting.getVideoList(params)
      if (statusCode === 200) {
        this.videos = data.videos
      }
    },
    open() {
      this.$refs.editDialog.open()
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    handleEdit(val) {
      this.$refs.editDialog.open(val)
    },
    handleDel(val) {
      this.$confirm('是否删除此条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_setting.delConfig(val).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handleChange(value) {
      console.log(value)
    },
    handlerSearch() {
      let params = {
        configType: this.configType,
        pageSize: this.pagesize,
        pageIndex: this.currentPage
      }
      Api_setting.getConfigList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.tableData = result.data.items
          this.totalCount = result.data.totalCount
          console.log('tableData==', this.tableData);
        }
      })
    },
    addRole() {
      let params = {
        projectId: this.projectId,
        authorityCompanyId: this.companyId,
        roleName: this.trainForm.roleName,
        status: this.trainForm.status,
        roleSort: Number(this.trainForm.roleSort)
      }
      if (this.trainForm.id) {
        params.id = this.trainForm.id
        Api_role.editRole(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      } else {
        Api_role.addRole(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      }

    },
  },
};
</script>
<style lang="scss" scoped>
.flex-end {
  display: flex;
  justify-content: flex-end;
}
</style>